import React from "react";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import { FormHelperText, FormLabel, Box } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const CustomPhoneField = ({
  control,
  name,
  label,
  required = false,
  isAltPhone = false,
  disabled = false,
  defaultCountry = "us",
  preferredCountries = ["us"],
  countryList = [],
  isPhoneFiledForceUpdate = true
}) => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={{
        phoneNumber: "",
        fullNumber: "",
        isPhoneNumberValid: !required,
        countryCode: "",
      }}
      rules={{
        validate: (value) => {
          if (
            required &&
            (!value.phoneNumber || value.phoneNumber.length < 9)
          ) {
            return t("Common.Invalid Phone");
          } else if (
            isAltPhone &&
            value.phoneNumber?.length !== value.countryCode?.length &&
            value.phoneNumber?.length < 9
          ) {
            return t("Common.Invalid Phone");
          }
          return true;
        },
      }}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        const handleChange = (inputValue, countryData, e, formattedValue) => {
          let isValid = false;
          if (isAltPhone) {
            if (inputValue === "" || inputValue === countryData.dialCode) {
              isValid = true;
            } else {
              isValid = inputValue.length >= 9;
            }
          } else {
            isValid = inputValue.length >= 9;
          }

          onChange({
            phoneNumber: inputValue,
            fullNumber: `+${inputValue}`,
            isPhoneNumberValid: isValid,
            countryCode: countryData?.dialCode || "",
            countryData,
          });
        };

        return (
          <Box>
            <FormLabel
              htmlFor={name}
              sx={{
                color: error ? "error.main" : "secondary.text",
                display: "flex",
                fontSize: "12px",
                fontWeight: "500",
                marginBottom: "4px",
                lineHeight: "1.2rem",
              }}
            >
              {label}
              {required && !isAltPhone && (
                <span
                  style={{
                    color: error ? "error.main" : "secondary.text",
                    marginLeft: 2,
                    fontSize: "12px",
                  }}
                >
                  *
                </span>
              )}
            </FormLabel>
            <input
              ref={ref}
              style={{
                position: "absolute",
                width: 0,
                height: 0,
                padding: 0,
                margin: 0,
                border: 0,
                opacity: 0,
                overflow: "hidden",
                pointerEvents: "none",
              }}
              tabIndex={-1}
            />
            <PhoneInput
              key={isPhoneFiledForceUpdate}
              inputProps={{
                name,
                required,
                disabled,
              }}
              country={!value?.countryData?.countryCode ? defaultCountry : ""}
              preferredCountries={preferredCountries}
              onlyCountries={countryList.length ? countryList : undefined}
              value={value?.fullNumber || ""}
              onChange={handleChange}
              inputStyle={{
                width: "100%",
                height: "52px",
                borderRadius: "12px",
                fontSize: "16px",
                background: "var(--inputs)",
                boxShadow: "none",
              }}
              masks={{ us: "...-...-...." }}
              specialLabel=""
              enableSearch={false}
              enableLongNumbers={false}
              disableSearchIcon={false}
              countryCodeEditable={false}
            />

            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </Box>
        );
      }}
    />
  );
};

export default CustomPhoneField;
